import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import ActualiteSevice from "../service/ActualiteSevice";
import bigFeuille from '../assets/images/bigfeuille-bg.png';
import calendrier from '../assets/images/calendrier.svg';

import maison from '../assets/images/maison.svg';
import {urlDirectus} from "../config/Globals";

export const EnCeMoment = () => {
    const[actualites, setActualites] = useState([]);
    const[loadingActualites, setLoadingActualites] = useState(1);
    const fetchActualites = async() => {
        try{
            const data = await ActualiteSevice.findAll();
            setActualites(data);
            setLoadingActualites(false);
        }catch (error){

        }
    }

    useEffect(() => {
        fetchActualites();
    }, []);

    return (
        <>
            <Helmet>
                <title>En ce moment dans le vignoble</title>
                <meta name="description" content=" En ce moment dans le vignoble" />
            </Helmet>
            <main class="type">
                <section class="bg-light">
                    <div class="container px-4 pt-lg-5 pb-5 position-relative z-1">
                        <img src={bigFeuille} alt="Feuilles" class="col-10 col-lg-6 position-absolute end-0 top-0 pe-4 pe-lg-0 pt-5 z-0" />
                        <div class="row pt-lg-4 pb-lg-5 position-relative z-1">
                            <div class="col-12">
                                <nav aria-label="breadcrumb" class="my-4">
                                    <ol class="custom-breadcrumb">
                                        <li class="breadcrumb-item-custom">
                                            <a href="/" class="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" class="breadcrumb-icon" />
                                            </a>
                                        </li>

                                        <li class="breadcrumb-separator">•</li>

                                        <li class="breadcrumb-item-custom active" aria-current="page">
                                            En ce moment dans le vignoble
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div class="col-12">
                                <h1 class="display-5 fw-sb mb-3">En ce moment dans le vignoble</h1>
                                <div class="fw-b fs-6">
                                    <p>Retrouvez ici les principales phases de la lutte contre la Flavescence dorée en Bourgogne.</p>
                                </div>
                            </div>
                        </div>
                        {
                            actualites.map((actu, index) => {
                             return (
                                 <div key={actu.id} className="row py-3 py-lg-5 position-relative z-1">
                                     <div className="col-12 col-lg-3 pe-lg-0">
                                         <img src={urlDirectus+"assets/"+actu.image} alt={"Photo " + actu.titre} className="visuel-en-ce-moment w-100 h-100 object-fit-cover"/>
                                     </div>
                                     <div className="col-12 col-lg-9 ps-lg-0">
                                         <div className="bg-white p-4 p-md-5 d-flex flex-column align-items-start">
                                             <h2 className="fw-sb mb-4">{actu.titre}</h2>
                                             <div
                                                 className="d-flex align-items-center justify-content-center justify-content-lg-start gap-2 fs-5 mb-2 text-marron">
                                                 <img src={calendrier} alt="" className="object-fit-contain"/>
                                                 <span className="date-en-ce-moment">{new Date(actu.date_actu).toLocaleDateString('fr-FR')}</span>
                                             </div>
                                             <div className="fs-6 lh-normal mb-4" dangerouslySetInnerHTML={{__html : actu.contenu}}>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             )
                            })
                        }
                    </div>
                </section>
            </main>
        </>
    );
}